import { useContext } from "react";

import {
  ColorModeContext,
  ColorModeContextValue,
} from "../contexts/ColorModeContext";

/**
 * The Light / Dark / Auto appearance: `{ preference, resolvedMode, setPreference }`.
 * Must be used under `<ColorModeProvider>` (mounted in index.tsx).
 */
export function useColorMode(): ColorModeContextValue {
  const context = useContext(ColorModeContext);
  if (!context) {
    throw new Error("useColorMode must be used inside <ColorModeProvider>.");
  }
  return context;
}

export default useColorMode;
